
import {AiFillPhone ,AiFillLinkedin} from "react-icons/ai";
import {MdEmail, MdLocationOn } from "react-icons/md";
import{SiTeamspeak } from "react-icons/si";
const Contact = () => {
  return (
    <div className="ml-72">
      <section className="contact pt-48 " id="contact">
        <div className="contact-container">
          <div className="main-title">
            <h2 className="title">
              Contact<span>Me</span>
              
            </h2>
          </div>
          <div className="contact-content-con">
            <div className="left-contact">
              <h4>Contact me Here</h4>
              <p>
                I am an exceptionally hard-working and creative individual,
                driven by a passionate desire to acquire new skills and
                knowledge. You can easily reach out to me through any of the
                contact methods provided below. I am always eager to explore new
                opportunities and connect with like-minded individuals. Thank
                you for considering me!
              </p>

              <div className="contact-info">
                <div className="contact-item">
                  <div className="icon">
                    <MdLocationOn />
                   <p> Location</p>
                  </div>

                  <p>: Cupertino(CA), USA</p>
                </div>
                <div className="contact-item">
                  <div className="icon">
                  <AiFillPhone />
                    <p>Phone No</p>
                  </div>
                  <p>: +1 6503160240</p>
                </div>
                <div className="contact-item">
                  <div className="icon">
                    <MdEmail />
                    <p>Email</p>
                  </div>
                  <p>
                    <span>: triptikhandelwal1@gmail.com</span>
                  </p>
                </div>
                <div className="contact-item">
                  <div className="icon">
                  <AiFillLinkedin />
                    <p>Linkdin</p>
                  </div>
                  <p>
                    <span>
                      <a
                        href="https://www.linkedin.com/in/tripti-khandelwal-a2866b218/"
                        target="_blank"
                      >
                        : https://www.linkedin.com/in/tripti-khandelwal
                      </a>
                    </span>
                  </p>
                </div>
                <div className="contact-item">
                  <div className="icon">
                    <SiTeamspeak />
                     <p>Language</p>
                  </div>
                  <p>
                    <span>:English,Hindi</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
